import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { FormControl, TextField, InputAdornment } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  root: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
    paddingLeft: theme.spacing() * 2,
    paddingRight: theme.spacing() * 2,
    borderRadius: '2px',
    backgroundColor: theme.palette.secondary.light
  }
})

interface MyProps extends StyledProps {
  /** String for the name of the field */
  name: string,
  /** Value of the field */
  value?: any,
  /** React component of an icon */
  icon?: React.ReactElement<{position}>,
  /** Change handler */
  onChange?: (e) => void
  /** String for placeholder text within input */
  placeholder?: string,
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean
}

export class StandaloneTextInputComponent extends React.Component<MyProps> {
  static defaultProps = {
    name:        '',
    value:       '',
    onChange:    () => {},
    placeholder: '',
    searchIcon:  false,
    disabled:    false
    }

  render() {
    const {className, name, value, icon, onChange, disabled, classes, placeholder} = this.props

    const FieldIcon = () => {
      const position = icon && icon.props.position === 'right' ? 'end' : 'start'
      return (
        <InputAdornment position={position}>
          {icon}
        </InputAdornment>
      )
    }

    return (
      <FormControl className={className}>
        <TextField
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          classes={{root: classes.root}}
          InputProps={{
            disableUnderline: true,
            startAdornment:   icon && icon.props.position === 'left' ? <FieldIcon/> : null,
            endAdornment:     icon && icon.props.position === 'right' ? <FieldIcon/> : null
          }}
        />
      </FormControl>
    )
  }
}

@(withStyles as any)(styles)
export class StandaloneTextInput extends StandaloneTextInputComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/StandaloneTextInput.tsx